/* eslint-disable max-classes-per-file */
import { ColorGradeVisualizer, Visualizer } from '@urbanmix-tech/um-embedded';

export class CategoryGradientVisualizer extends Visualizer {
  categoryVisualizers: Record<string, ColorGradeVisualizer>;

  constructor(categoryVisualizers: Record<string, ColorGradeVisualizer>) {
    super();
    this.categoryVisualizers = categoryVisualizers;
  }

  getColor(value: any) {
    if (typeof value !== 'string') {
      return '#000000';
    }
    const [category, val] = value.split('_');
    // console.log('CategoryGradientVisualizer', value,category, val);
    const visualizer = this.categoryVisualizers[category];
    // console.log('visualizer', visualizer);
    let color = visualizer?.getColor(+val)
    // console.log('color', color);
    return color || '#000000';
  }
}

export class GenericDistinctVisualizer extends Visualizer {
  colorMap: Map<any, string>;

  constructor(colorMap: Map<any, string>) {
    super();
    this.colorMap = colorMap;
  }

  getColor(value: any) {
    let color = this.colorMap.get(value);
    if (color) {
      return color;
    } else {
      return '#0000FF';
    }
  }
}

export class StateVisualizer extends Visualizer {
  constructor() {
    super();
  }
  getColor(value: any): string {
    console.log('StateVisualizer', value);
    if (value === 'late') {
      return '#FFB6C1';
    } else if (value === 'done') {
      return '#00ff00';
    } else if (value === 'on time') {
      return '#B0E2FF';
    }
    return '#000000';
  }
}

export type ColorScaleOptions =
  | 'blues'
  | 'default'
  | 'purpleToYellow'
  | 'tealToMagenta'
  | 'earthTones'
  | 'rainbow'
  | 'pastel';

export const colorScales = {
  blues: [
    '#e6f7ff', // Very light blue - least expensive
    '#bae7ff',
    '#91d5ff',
    '#69c0ff',
    '#40a9ff',
    '#1890ff',
    '#096dd9',
    '#0050b3',
    '#003a8c',
    '#002766', // Deep navy blue - most expensive
  ],
  default: [
    '#C1E1C1', // Light green - least expensive
    '#C7E9FF', // Light blue
    '#ADD8E6', // Light blue
    '#F0E68C', // Khaki
    '#FFD700', // Gold
    '#FFA500', // Orange
    '#FF6347', // Tomato
    '#FF4500', // Red-orange
    '#DC143C', // Crimson
    '#800000', // Maroon - most expensive
  ],
  purpleToYellow: [
    '#9370DB', // Medium Purple
    '#AB82FF', // Medium Purple
    '#CCCCFF', // Lavender
    '#E6E6FA', // Lavender
    '#FFFACD', // Lemon Chiffon
    '#FFFF99', // Light Yellow
    '#FFEC8B', // Light Golden
    '#FFD700', // Gold
    '#FFA500', // Orange
    '#FF8C00', // Dark Orange
  ],
  tealToMagenta: [
    '#E0FFFF', // Light Cyan
    '#AFEEEE', // Pale Turquoise
    '#48D1CC', // Medium Turquoise
    '#20B2AA', // Light Sea Green
    '#9370DB', // Medium Purple
    '#BA55D3', // Medium Orchid
    '#DA70D6', // Orchid
    '#FF69B4', // Hot Pink
    '#FF1493', // Deep Pink
    '#C71585', // Medium Violet Red
  ],
  earthTones: [
    '#F5F5DC', // Beige
    '#DEB887', // Burlywood
    '#D2B48C', // Tan
    '#BC8F8F', // Rosy Brown
    '#A0522D', // Sienna
    '#8B4513', // Saddle Brown
    '#800000', // Maroon
    '#696969', // Dim Gray
    '#4B0082', // Indigo
    '#191970', // Midnight Blue
  ],
  rainbow: [
    '#4B0082', // Indigo
    '#9400D3', // Dark Violet
    '#0000FF', // Blue
    '#00BFFF', // Deep Sky Blue
    '#00FF7F', // Spring Green
    '#ADFF2F', // Green Yellow
    '#FFFF00', // Yellow
    '#FFA500', // Orange
    '#FF4500', // Orange Red
    '#FF0000', // Red
  ],
  pastel: [
    '#E0FFFF', // Light Cyan
    '#E6E6FA', // Lavender
    '#B0E0E6', // Powder Blue
    '#98FB98', // Pale Green
    '#FAFAD2', // Light Goldenrod
    '#FFE4E1', // Misty Rose
    '#FFB6C1', // Light Pink
    '#FFC0CB', // Pink
    '#DDA0DD', // Plum
    '#DA70D6', // Orchid
  ],
  market: [
    '#d42d00',
    '#c94e2f',
    '#dd755a',
    '#ef9f8a',
    '#f3baad',
  ],
  affordable: [
    '#844886',
    '#7e5794',
    '#877aa8',
    '#907fc1',
    '#918dd2',
  ],
};
